import React, { useState, useEffect } from "react";
import DealershipDetails from "./dealershipdetails/DealershipDetails";
import { withTranslation } from "react-i18next";
import AcceptTermsAndConditions from "./termsAndConditions/AcceptTermsAndConditions";
import { InfoIconWithMessage } from "../../shared/infoIcon/InfoIcon";
import LoadTermsAndConditions from "./termsAndConditions/LoadTermsAndConditions";
import EmpMembership from "./EmpMembership";
import SubNav from "../../shared/subnav/SubNav";
import HasPermissionTo from "../../common/HasPermissionTo";

const DealerBusinessSettings = (props) => {
  const [selectedTab, setSelectedTab] = useState(props.startingTab);
  const [renderPage, setRenderPage] = useState(false);

  useEffect(() => {
    if (
      props.user.businessSettingsPage !== undefined &&
      props.user.businessSettingsPage !== null
    ) {
      setSelectedTab(props.user.businessSettingsPage);
    } else if (props.user?.updateBusinessSettingsTab) {
      props.user.updateBusinessSettingsTab(selectedTab);
    }
    setRenderPage(true);
  }, []);

  const handleTabChange = (event, newSelectedTab) => {
    setSelectedTab(newSelectedTab);
    if (props.user?.updateBusinessSettingsTab) {
      props.user.updateBusinessSettingsTab(newSelectedTab);
    }
    props.resetFromPending();
  };

  const getTabs = () => {
    return [
      {
        menuName: props.t("ProgressBar.empMembership"),
        enabled: true,
        id: "empMembership",
      },
      {
        menuName: props.t("ProgressBar.dealershipDetails"),
        enabled: true,
        id: "dealership-details",
      },
    ];
  };

  const renderTermsConditionsTab = () => {
    return props.isDealerAcceptingTerms ? (
      <AcceptTermsAndConditions {...props} />
    ) : (
      <>
        <div className="pagePaddingLeft pagePaddingTop">
          <InfoIconWithMessage
            message={props.t("AcceptTermsConditions.subheader")}
          />
        </div>
        <LoadTermsAndConditions {...props} />
        <HasPermissionTo
          perform={["empMembership:view"]}
          permissions={props.user.permissions.rolePermissions}
          render={() => {
            return <EmpMembership {...props} />;
          }}
        />
      </>
    );
  };

  return (
    renderPage && (
      <>
        <SubNav
          dashboard={false}
          selectedTab={selectedTab}
          title={props.t("GlobalNavBar.settings")}
          action={handleTabChange}
          tabs={getTabs()}
          restrictDropdown={props.restrictDropdown}
          {...props}
        />
        <div className="pageWrapper">
          {selectedTab === 0 && renderTermsConditionsTab()}
          {selectedTab === 1 && <DealershipDetails {...props} />}
        </div>
      </>
    )
  );
};

export default withTranslation("emp")(DealerBusinessSettings);
